import es from './locales/es'
// TODO: Add new locales
export default {
  es: es
}